module.exports = __webpack_public_path__ + "static/media/BioImage2.f3b55ea2.jpg";